let dxbChildren = data => {
  var arr = [];
  var shape = ['0:8', '1:7', '2:6', '3:5', '4:4', '5:3', '6:2', '7:1', '8:0'];

  // var str = ['big', 'small'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var num = row.row.ball_json.numSpread.bigSmall[shape[i]];
        var number = data[0].ball_json.numSpread.bigSmall[shape[i]];
        if (num == 0) {
          return <span class={`table_join_red hp_red`}>{shape[i]}</span>;
        } else if (number > row.index) {
          return <span class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <span class="lost_info">{num}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let dxChildren = (data, ball) => {
  var arr = [];
  var shape = ['大', '小'];
  var str = ['big', 'small'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children_${ball}`;
      obj.render = (h, row) => {
        var num = row.row.ball_json[ball].ballBigSmall[str[i]];
        var number = data[0].ball_json[ball].ballBigSmall[str[i]];
        if (num == 0) {
          return <span class={`table_join_red_span hp_red`}>{shape[i]}</span>;
        } else if (number > row.index) {
          return <span class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <span class="lost_info">{num}</span>;
        }
        // } else {
        //   return <span class="">{num}</span>;
        // }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const hpten = (data, ballindex) => {
  let list = Vue => {
    var ball = ['一', '二', '三', '四', '五'];
    let arr = [
      {
        title: '期号',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 130
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 200,
        className: `table_issueId`,
        render: (h, { row }) => {
          return (
            <div class="hp_balls">
              {row.balls.split(',').map((x, i) => {
                return <span key={i}>{x}</span>;
              })}
            </div>
          );
        }
      }
    ];
    for (let i = 1; i < 9; i++) {
      var o = {};
      o.title = `第${i}位`;
      o.align = 'center';
      o.className = `table_issueId`;
      o.children = dxChildren(data, `ball${i}`);
      arr.push(o);
    }
    arr.push({
      title: `大小比走势`,
      align: 'center',
      className: `table_issueId`,
      children: dxbChildren(data)
    });
    return arr;
  };

  return { list };
};

export default hpten;



// WEBPACK FOOTER //
// ./src/pages/Trend/Daxiaozhoushi/columns/hpten.js